module.exports = __webpack_public_path__ + "assets/emblem_navbar.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/emblem_navbar.svg
 ** module id = 214
 ** module chunks = 1
 **/